// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"NotificationsDesctopView__contentWrapper__1E26F"};